import React from "react";

const Subscribe = () => {
  return (
    <div className="subscribe py-28 px-24 md:px-6">
      <div className="grid grid-cols-2 md:grid-cols-1 gap-8 items-center">
        <div>
          <h1 className="text-2xl text-secondary text-center">
            Join our mailing list for regular updates
          </h1>
        </div>
        <div className="w-4/5 md:w-full">
          <form action="submit" className="space-y-6">
            <input
              type="email"
              className="w-full h-12 bg-[#979797]/20 px-4 outline-none placeholder:text-secondary"
              name="email"
              placeholder="E-MAIL"
            />
            <button className="h-12 w-full bg-secondary text-white">
              SUBSCRIBE
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Subscribe;
